import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Spin } from 'antd';
import { UserService } from 'app/services/user';
import { ProfileObject } from 'app/interfaces/UserProfile';
import { AppURLs } from 'app/utils/appURLs';
import { getCustomIdFromUrl } from 'app/utils/url';

const EntityRedirect = () => {
  const transactionId = getCustomIdFromUrl('transactionID');
  const checkId = getCustomIdFromUrl('checkID');
  const navigate = useNavigate();

  useEffect(() => {
    const handleEntityRedirect = async () => {
      try {
        const userService = new UserService();
        const response = await userService.getUserProfile();
        const profiles: ProfileObject[] = response?.data?.profiles || [];

        // Helper function to check if user has a specific role
        const hasRole = (role: string) =>
          profiles.some(
            (profile) => profile.role.toLowerCase() === role.toLowerCase()
          );

        // Determine which redirect to perform based on available IDs and roles
        if (checkId) {
          if (hasRole('officeadmin')) {
            navigate(AppURLs.officeAdminDashboardValidation(checkId));
          } else if (hasRole('compliance')) {
            navigate(AppURLs.complianceDashboardValidation(checkId));
          } else {
            navigate(AppURLs.agentLogin());
          }
        } else if (transactionId) {
          if (hasRole('agent')) {
            navigate(AppURLs.agentDashboardTransaction(transactionId));
          } else if (hasRole('compliance')) {
            navigate(AppURLs.complianceDashboardTransaction(transactionId));
          } else {
            console.error('No agent or compliance role found');
            navigate(AppURLs.agentLogin());
          }
        } else {
          // If neither ID is present, redirect to login page
          navigate(AppURLs.agentLogin());
        }
      } catch (error: any) {
        console.log('Error fetching user profile:', error);
        navigate(AppURLs.agentLogin());
      }
    };

    handleEntityRedirect();
  }, []);

  return (
    <div className="flex justify-center items-center h-screen">
      <Spin size="large" />
    </div>
  );
};

export default EntityRedirect;
